import { render, staticRenderFns } from "./tagModal.vue?vue&type=template&id=26918cea&scoped=true&"
import script from "./tagModal.vue?vue&type=script&lang=js&"
export * from "./tagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26918cea",
  null
  
)

export default component.exports